import { PageLayout } from '@/components/PageLayout/PageLayout';
import { NOT_FOUND } from '@/dictionary/common';
import { ROUTES } from '@/dictionary/routes';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';
import { Button } from '@mantine/core';
import { Link } from 'react-router-dom';
import classes from './NotFoundPage.module.css';

export function NotFoundPage() {
  useDocumentTitle(`סינרו | ${NOT_FOUND.title}`);

  return (
    <PageLayout>
      <section className={classes.section}>
        <p className={classes.code}>{NOT_FOUND.code}</p>
        <h1 className={classes.title}>{NOT_FOUND.title}</h1>
        <p className={classes.body}>{NOT_FOUND.body}</p>
        <Button component={Link} to={ROUTES.home} size="lg">
          {NOT_FOUND.cta}
        </Button>
      </section>
    </PageLayout>
  );
}
